// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1MYPi","list":"styles_list__1GDJw"};